import CityPageTemplate from "../city-template/CityPageTemplate";
import { leesburgVaConfig } from "./data";

export default function LeesburgVaPage() {
  return <CityPageTemplate config={leesburgVaConfig} />;
}